import {
  Box,
  Text,
  Button,
  IconChevronRight,
  Hidden,
  Link,
  useResponsiveValue
} from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import useProfile from '@/hooks/use-profile'
import PopoverUpgrade from './PopoverUpgrade'

type TriggerCardProps = {
  id: string
  title: string
  description: string
  onClick: () => void | undefined
}

const TriggerCard = ({ id, title, description }: TriggerCardProps) => {
  const { t } = useTranslation()
  const profileData = useProfile()
  const isEssentialPlan = profileData?.company_info?.base_plan_name === 'essentials-plan-monthly'
  const freeAutoReplyMessage = 'first_tenant_message_received'
  const isDisabled = isEssentialPlan && id !== freeAutoReplyMessage
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })

  const WrapperComponent = ({ children }: { children: React.ReactNode }) =>
    isDisabled ? (
      <Box
        display="flex"
        gap="small"
        justifyContent="spaceBetween"
        padding="medium"
        alignItems={'center'}
        borderRadius="standard"
        border="borderNeutralLight"
        background="surface"
        key={id}
      >
        {children}
      </Box>
    ) : (
      <Link href={`/settings/auto-reply/manage?trigger=${id}`}>
        <Box
          display="flex"
          gap="small"
          justifyContent="spaceBetween"
          padding="medium"
          alignItems={isMobile ? 'flexStart' : 'center'}
          borderRadius="standard"
          border="borderNeutralLight"
          background="surface"
          key={id}
        >
          {children}
        </Box>
      </Link>
    )

  return (
    <WrapperComponent>
      <Box display="flex" flexDirection="column" gap="small">
        <Text tone={isDisabled ? 'disabled' : 'secondary'} size="medium" weight="strong">
          {title}
        </Text>
        <Text tone={isDisabled ? 'disabled' : 'tertiary'} size="small">
          {description}
        </Text>
      </Box>
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        {isDisabled && <PopoverUpgrade trackingId={id} />}
        <Box>
          <Hidden below="tablet">
            <Button size="small" variant={'ghost'} id={id} disabled={isDisabled}>
              {t('l.settings.view.auto_reply.manage.label', 'Manage')}
            </Button>
          </Hidden>
          {!isDisabled && (
            <Hidden above="mobile">
              <IconChevronRight />
            </Hidden>
          )}
        </Box>
      </Box>
    </WrapperComponent>
  )
}

export default TriggerCard
